module.exports = __webpack_public_path__ + "img/strideSideImg@2x.029194ec.png";